
import { Product } from "@/lib/supabase/products/types";
import { ProductFormState } from "../types";

export const prepareProductData = (
  productState: ProductFormState,
  isNewProduct: boolean
): Partial<Product> => {
  const {
    name,
    overview,
    description,
    price,
    discountPrice,
    sku,
    quantity,
    lowStockThreshold,
    isOutOfStock,
    isStockManaged,
    mediaUrls,
    category,
    benefits,
    faqs,
    weight,
    dimensions,
    tags,
    isVisible,
    status,
    currency,
    shopId,
    formId,
    organizationId
  } = productState;

  // Parse numeric values
  const parsedPrice = price ? parseFloat(price) : 0;
  const parsedDiscountPrice = discountPrice ? parseFloat(discountPrice) : null;
  const parsedWeight = weight ? parseFloat(weight) : null;

  // Calculate actual stock quantity
  const stockQuantity = isOutOfStock ? 0 : quantity;

  // Ensure media URLs is an array and filter invalid entries
  const safeMediaUrls = Array.isArray(mediaUrls) 
    ? mediaUrls.filter(url => url && typeof url === 'string' && url.trim() !== '') 
    : [];
  
  console.log('Product preparing with media URLs:', safeMediaUrls);

  // Prepare the data object
  const productData: Partial<Product> = {
    name,
    price: parsedPrice,
    description,
    overview: overview || null,
    discount_price: parsedDiscountPrice,
    sku: sku || null,
    stock_quantity: stockQuantity,
    low_stock_threshold: lowStockThreshold,
    is_stock_managed: isStockManaged,
    media_urls: safeMediaUrls,
    category: category || null,
    benefits,
    faqs,
    weight: parsedWeight,
    dimensions,
    tags,
    is_visible: isVisible,
    status,
    currency,
    shop_id: shopId
  };

  // Add organization_id field to product data
  if (organizationId !== undefined) {
    productData.organization_id = organizationId;
  }

  // Add form_id field to product data
  if (formId !== undefined) {
    productData.form_id = formId;
  }
  
  console.log('Prepared product data with formId:', formId);
  console.log('Prepared product data with media URLs:', productData.media_urls);

  return productData;
};
